var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMaximize = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9 2.6C21.8 2.4 21.6 2.2 21.4 2.1C21.3 2 21.1 2 21 2H15C14.4 2 14 2.4 14 3C14 3.6 14.4 4 15 4H18.6L13.3 9.3C12.9 9.7 12.9 10.3 13.3 10.7C13.5 10.9 13.8 11 14 11C14.2 11 14.5 10.9 14.7 10.7L20 5.4V9C20 9.6 20.4 10 21 10C21.6 10 22 9.6 22 9V3C22 2.9 22 2.7 21.9 2.6ZM9.3 13.3L4 18.6V15C4 14.4 3.6 14 3 14C2.4 14 2 14.4 2 15V21C2 21.1 2 21.3 2.1 21.4C2.2 21.6 2.4 21.8 2.6 21.9C2.7 22 2.9 22 3 22H9C9.6 22 10 21.6 10 21C10 20.4 9.6 20 9 20H5.4L10.7 14.7C11.1 14.3 11.1 13.7 10.7 13.3C10.3 12.9 9.7 12.9 9.3 13.3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMaximize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconMaximize.ecd8ce187c9f738668ef05a1e95164b8.svg";